<pmv-main-content>
	<pmv-main-content-header title="Envio de Arquivos" [subtitle]="title">
		<pmv-loading [isLoading]="loading"></pmv-loading>
	</pmv-main-content-header>
</pmv-main-content>
<pmv-main-content-body>
	<div class="row">
		<div class="col-md-12" style="margin-bottom: 10px;">
			
		</div>
	</div>

	<h1 style="display: block;text-align: center; line-height: 150%;font-size: .95em;color:#2D699F;">{{editalAnoPss}}</h1>
	<br />

	<div class="row" *ngIf="mostrar">
		<div class="col-md-12" style="margin-bottom: 10px;">
			<pmv-fieldset [header]="arquivotitle" class="filtros-fieldset">
				<div class="form-group">
					<div class="col-md-12" style="margin-top: 15px;">
						<pmv-datatable [loading]="loading" [paginator]="false" [lazy]="true"
							 [values]="listaArquivos" [columns]="columns"
							[actions]="actions" (onPageChange)="GetFilter($event)" (onAction)="onAction($event)"
							[rows]="itemsPerPage" [first]="first">
						</pmv-datatable>
					</div>
				</div>
			</pmv-fieldset>
		</div>
	</div>
	
	<div class="row" *ngIf="editalArquivos.envioArquivoLiberado">
		<form #form="ngForm" *ngIf="editalArquivos.envioArquivoLiberado" 
					validateOnSubmit (submit)="onSubmit(form)">
			<div class="col-md-12" style="margin-bottom: 10px;">
				<pmv-fieldset header="Dados do Cadastro do Arquivo" class="filtros-fieldset">
					<div class="row" style="margin-bottom: 10px;">
						<div class="form-group">
							<div class="col-md-12">
								<pmv-single-file-upload class="filePmv" [(ngModel)]="arquivo"
									[(nomeArquivo)]="nomeArquivo" name="filesValue" (change)="validaArquivo($event)">
								</pmv-single-file-upload>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="form-group">
							<div class="col-md-4 col-xs-12">
								<pmv-dropdown [(ngModel)]="anexo.tipoArquivo" [disabled]="loading" label="Tipo do Arquivo" name="tipoArquivo"
								  [options]="tipoArquivoOptions" optionLabelField="descricao" optionValueField="id" defaultOption=" ">
								</pmv-dropdown>
							  </div>
							
							<br />
							<div class="col-md-2">
								<button type="submit" class="btn btn-primary">Enviar</button>
							</div>
						</div>
					</div>
					<br />

				</pmv-fieldset>
			</div>
		</form>
	</div>


	<div class="row">
		<div class="col-md-12" style="margin-top: 15px;">
		  <a (click)="voltar()" asp-page="Index" title="Voltar" class="btn btn-warning btn-md pull-left">
			<span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
			Voltar
		  </a>
		</div>
	  </div>
</pmv-main-content-body>


// WEBPACK FOOTER //
// ./src/app/pages/candidato/candidato-enviar-arquivo/candidato-enviar-arquivo.component.html